module.exports = __webpack_public_path__ + "img/VP-Profi13-Profiles.f2b824ea.jpg";